import permission from '_lib/permission'
import Vue from 'vue'
import { USER_BGM_SUFFIX } from '@/common/constants/rtc';
import { CHANNEL_TYPES } from '@/common/constants/channel';
import { ROOM_ICON_ID_MAP } from "_lib/constants/room";
import { getBasicRoomData } from '_lib/utils/utilsRoom';
import EventBus from '_lib/EventBus';
import { setChannelSettings } from '_api/channel'

const Room = {
  state: () => ({
    // 接口返回的全部房间数据，包括channels，my_room_info，read_states，room，room_id
    // 原cur_room_data getters仍然保留，数据为cur_room_whole_data.room
    cur_room_whole_data: {},
    cur_channel_data: {},
    cur_text_channel_data: {}, // 当前文字频道信息
    cur_resource_channel_data: {}, // 当前资源频道信息
    channel_connecting: false, // 正在频道链接中, 1: 正常连接中； 2: 重连连接中
    enter_channel_ws_connecting_channel_id: '', // enterChannel发送后，等待ws返回的连接状态
    rtc_connection: 0, // rtc链接状态，具体数值见RTC_CONTTECTION_STATE
    top_room_id: [], //置顶房间id
    room_list: [], // 房间列表
    temp_role_data: {}, // 临时权限，{temp_role, room_id, roles_list}
    customRoomEmoji: {
      emojis: [],
      stickers: [],
    }, // 房间emoji & 大表情列表
    all_notify_settings: {}, // 所有房间&频道的通知设置
    default_notify_settings: {
      default_channel_setting: {}, // 频道默认通知设置
      audio_channel_default_setting: {} // 语音频道和临时频道默认通知设置
    }, // 频道默认通知设置
    all_unread_states: {}, // 所以房间&频道的未读消息数量
    bgm_state: {}, // 伴奏状态
    sound_message_active: {}, // 语音包播放中统计
    preview_theme_data: {}, // 预览房间主题
    cur_room_banned_time: 0, // 当前房间被禁言剩余时间
    anchor_mute_user_ids: {}, // 主播模式下被静音的用户列表
    show_theme_manager: false, // 是否展示房间个性化设置
    is_phone_mic_connecting: false, // 是否已连接手机端麦克风
    room_channel_list_scroll_top: {}, // 房间频道列表滚动位置
    enter_default_channel_result: null, // 进入房间后，后端自动进入默认频道的返回数据，对应enterChannel socket请求返回的enter_channel字段
    is_from_team_center: false, // 是否从组队中心进入房间
    is_from_team_card: false, // 是否从组队卡片进入房间
    temp_private_invite: null,
    anchor_white_list: [], // 主播模式白名单,

    new_member_guide: { // 新手教程
      available_channels: [], // 当前频道的可用频道
      guidance: {
        banner: '',
        resource: [],
      },
      questions: [], // 当前频道的问题设置
      customization_switch: false, // 新手教程开关
      room_id:'',
      available_switch: false, // 可用频道开关
      question_switch: false, // 设置问题开关
      guidance_switch: false, // 指南开关
    },
    new_member_guider_config: { // 房间新手教程组件配置
      show: false,
      type: '',
      questions: [],
      backCb: null,
    },
    stash_room_data: {}, // 编辑房间资料切换到背景编辑时暂存编辑内容
    room_member_num: 0, // 房间当前在线人数
    index_task: {}, // 广告位
    discover_enter_way: '', // 数据埋点 首页进入房间的方式 /constants/room.ts 中的DISCOVER_ENTER_WAY
    is_speak_freely: true, // 当前频道是否允许自由发言
    is_show_game_display_block: false, // 是否展示正在游玩游戏展示区
    expend_collapse_ids: [], // 多人语音的展开列表
    manually_expanded_channel_ids: {}, // 用户手动设置的频道展开/折叠状态，key为频道ID，value为'on'(展开)/'off'(折叠)
    wait_enter_temporary_channel_id: '', // 等待进入的临时频道id
    // user_id | channel_id -> channel，消息所关联的频道列表，
    // 普通消息通过user_id -> channel存储，组队贴通过组队贴channel_id -> channel存储
    msg_channels: {}, 
    hide_channel_group_ids: {}, // 隐藏频道组id, key: room id, value: 隐藏的频道组id列表
    hide_channel_group_info: {}, // 隐藏频道组信息, key: group channel id, value: 隐藏的频道组信息列表
    has_more_channel_group: [], // 大型房间中，分组未加载完的数据列表
    out_screen_group_info: {}, // 频道分页中返回的first_group_info字段，超出分页范围的分组信息
    cur_team_channel: {}, // 当前组队频道id
    room_team_binds: [], // 房间组队设置
    global_team_setting: {}, // 全局组队信息

    applying_host_users: [], // 申请上麦的用户列表
    hosts: [], // 主持人列表
    is_me_applying_host: false, // 当前用户是否申请上麦
    cur_global_team: {}, // 当前全局组队信息
  }),
  getters: {
    cur_room_whole_data: (state) => state.cur_room_whole_data,
    cur_text_channel_data: (state) => state.cur_text_channel_data,
    cur_resource_channel_data: (state) => state.cur_resource_channel_data,
    only_text_channel_data: (state) => {
      // 如果当前文字频道是语音频道类型，就是仅文字的情况
      if (CHANNEL_TYPES.has_audio_types.includes(state.cur_text_channel_data.channel_type)) {
        return state.cur_text_channel_data
      }
      return {}
    },
    cur_room_data: (state) => {
      return state.cur_room_whole_data.room || {}
    },
    cur_room_data_is_visitor: (state) => state.cur_room_whole_data.my_room_info?.is_visitor,
    cur_room_data_is_big: (state) => state.cur_room_whole_data.room?.room_setting?.is_big,
    cur_room_read_anc_time: (state) => state.cur_room_whole_data.my_room_info?.read_anc_time,
    cur_room_bots: (state) => state.cur_room_whole_data.bot_infos || [],
    channel_data: (state) =>{
      if(state.cur_resource_channel_data.room_id == state.cur_room_whole_data.room_id) {
        return state.cur_resource_channel_data
      } else if (state.cur_text_channel_data.room_id == state.cur_room_whole_data.room_id) {
        return state.cur_text_channel_data
      } else if (state.cur_channel_data.room_id == state.cur_room_whole_data.room_id) {
        return state.cur_channel_data
      }
      return {}
    },
    channels: (state) => {
      return state.cur_room_whole_data.channels || []
    },
    // 当前房间的roles，如果需要非当前房间的数据，用DataCahce.js中 getRoomRoleCache 函数
    cur_roles_list: (state) => state.cur_room_whole_data.roles || [],
    // 当前房间的my_roles，如果需要非当前房间的数据，用DataCahce.js中 getRoomRoleCache 函数
    cur_my_roles: (state) => state.cur_room_whole_data.my_roles || [],

    cur_channel_data: (state) => state.cur_channel_data,
    cur_channel_others_bilibili_living: (state, getters, rootState) => {
      return rootState.settings.global_config?.switches?.check_bilibili
        && state.cur_channel_data.members 
        && state.cur_channel_data.members.some((user) => user.bilibilier && user.user_id != rootState.user.user_info.user_id)
    },
    channel_connecting: (state) => state.channel_connecting,
    enter_channel_ws_connecting_channel_id: (state) => state.enter_channel_ws_connecting_channel_id,
    rtc_connection: (state) => state.rtc_connection,
    top_room_id: (state) => state.top_room_id,
    room_list: (state) => state.room_list,
    temp_role_data: (state) => state.temp_role_data,
    customRoomEmoji: (state) => state.customRoomEmoji,
    all_notify_settings: (state) => state.all_notify_settings,
    default_notify_settings: (state) => state.default_notify_settings,
    all_unread_states: (state) => state.all_unread_states,
    bgm_state: (state) => state.bgm_state,
    sound_message_active: (state) => state.sound_message_active,
    preview_theme_data: (state) => state.preview_theme_data,
    show_theme_data: (state, getters, rootState) => {
      let obj = {}
      let room_theme_data = state.cur_room_whole_data.room
      let { bg_pic, main_color_v2, bg_color, bar_color} = room_theme_data || {}
      
      if (Object.keys(state.preview_theme_data).length > 0) {
        obj = JSON.parse(JSON.stringify(state.preview_theme_data))
      } else if (
        room_theme_data
        && room_theme_data.can_decorate
        && state.cur_room_whole_data.my_room_info?.show_room_bg
        && !(rootState.user.user_theme_setting && rootState.settings.user_account_settings.show_personal_deco)
        && (bg_pic || bg_color || bar_color || (main_color_v2 !== null && main_color_v2 !== undefined))
      ) {
        obj = {
          bg_color: room_theme_data.bg_color,
          transparency: room_theme_data.transparency,
          blur_rate: room_theme_data.blur_rate,
          main_color_v2: room_theme_data.main_color_v2,
          bar_color: room_theme_data.bar_color,
          bar_main_color_v2: room_theme_data.bar_main_color_v2,
          bg_pic: room_theme_data.bg_pic,
          bg_pic_main_color: room_theme_data.bg_pic_main_color,
          show_channel_bar_filter: !!room_theme_data.show_channel_bar_filter,
        }
      } else if (rootState.user.user_theme_setting) {
        obj = {...rootState.user.user_theme_setting}
        obj.show_channel_bar_filter = !!obj.show_channel_bar_filter
      }
      if (obj.bar_color && typeof obj.bar_color === 'string') {
        obj.bar_color = obj.bar_color.split(',')
      }
      if (obj.bg_color && typeof obj.bg_color === 'string') {
        obj.bg_color = obj.bg_color.split(',')
      }
      return obj
    },
    cur_room_banned_time: (state) => state.cur_room_banned_time,
    anchor_mute_user_ids: (state) => state.anchor_mute_user_ids,
    show_theme_manager: (state) => state.show_theme_manager,
    is_phone_mic_connecting: (state) => state.is_phone_mic_connecting,
    room_channel_list_scroll_top: (state) => state.room_channel_list_scroll_top,
    enter_default_channel_result: (state) => state.enter_default_channel_result,
    is_from_team_center: (state) => state.is_from_team_center,
    is_from_team_card: (state) => state.is_from_team_card,
    temp_private_invite: (state) => state.temp_private_invite,
    anchor_white_list: (state) => state.anchor_white_list,
    room_customization: (state) => state.cur_room_whole_data.room?.customization || {},

    // 新手教程数据设置相关
    stash_room_data: (state) => state.stash_room_data,
    voice_panel_height: (state, getters, rootState) => {
      let height = 62;
      let { channel_id, refuse_user_audio } = state.cur_channel_data
      const cur_text_channel_data = state.cur_text_channel_data
      if (channel_id && refuse_user_audio) {
        height += 81
      } else if (channel_id) {
        height += 104
      } else if (cur_text_channel_data.channel_id && CHANNEL_TYPES.has_audio_types.includes(cur_text_channel_data.channel_type)) {
        height += 58
      }
      if(state.index_task.task_name && !getters.hide_advertisement_panel) {
        height += 42
      }
      if(state.is_show_game_display_block) {
        height += 60
      }
      // 未实名 & 频道里有b站主播
      if (getters.cur_channel_others_bilibili_living && !rootState.user.user_info?.verified_info?.id_card) {
        height += 84
      }
      return height + 'px'
    },
    room_member_num: (state) => state.room_member_num,
    // 新手教程数据相关 本地缓存
    customization_switch: (state) => state.new_member_guide.customization_switch,
    available_channels: (state) => state.new_member_guide.available_channels,
    questions: (state) => state.new_member_guide.questions,
    guidance: (state) => state.new_member_guide.guidance,
    new_member_guide: (state) => state.new_member_guide,

    // 新手教程组件相关
    new_member_guider_config: (state) => state.new_member_guider_config,

    index_task: (state) => state.index_task,
    hide_advertisement_panel: (state, getters) => {
      return getters.cur_room_data?.room_icon?.some(item => item.room_icon_id === ROOM_ICON_ID_MAP['game-official'])
        && !getters.index_task?.show_firm_room 
        && !getters.index_task?.show_room_ids?.includes(getters.cur_room_data.room_id)
    },

    discover_enter_way: (state) => state.discover_enter_way,

    is_speak_freely: (state) => state.is_speak_freely,

    cur_room_talkable: (state) => {
      if(!state.cur_room_whole_data.room) return {}
      const { talkable } = state.cur_room_whole_data.room
      if(!talkable) return {}
      if(Object.keys(talkable).length) {
        return talkable
      }
      return {}
    },
    limitations: (state, getters, rootState) => {
      const { level, verified_info, user_id } = rootState.user.user_info;
      if(getters.cur_room_data.create_by == user_id) return null
      if(!!Vue.prototype.$permission.judge('ManageServer')) return null
      const { level: levelLimit, verified: verifiedLimit } = getters.cur_room_talkable;
      let limit = {
        value: [],
      }
      if (levelLimit !== undefined && level < levelLimit) {
        limit.value.push(`小黑盒等级达到Lv.${levelLimit}`)
      }
      if (verifiedLimit && !verified_info) {
        limit.value.push('实名认证')
        limit.handleJump = () => {
          EventBus.$dynamic('VerifiedDialog', false)
        }
      }
      if (limit.value.length) {
        limit.tooltip = `已被限制发言，需要 ${limit.value.join('、')} 解锁`
      }
      return limit.value.length > 0 ? limit : null;
    },
    room_user_notify_settings: (state) => state.cur_room_whole_data.user_notify_settings,
    cur_room_unread_act_count: (state) => state.cur_room_whole_data.my_room_info?.room_act_unread_count,
    cur_room_last_close_room_act_id: (state) => state.cur_room_whole_data.my_room_info?.last_close_room_act_id,
    is_show_game_display_block: (state) => state.is_show_game_display_block,
    expend_collapse_ids: (state) => state.expend_collapse_ids,
    manually_expanded_channel_ids: (state) => state.manually_expanded_channel_ids,
    room_guidance_data: (state) => {
      return state.cur_room_whole_data?.room?.customization?.guidance || {}
    },
    // 房间指南资源频道列表, 将被用于隐藏（not_show）
    guidance_channel_list: (state) => {
      return state.cur_room_whole_data?.room?.customization?.guidance?.resource?.map(item => String(item.channel_id)) ?? [];
    },
    wait_enter_temporary_channel_id: (state) => state.wait_enter_temporary_channel_id,
    msg_channels: (state) => state.msg_channels,
    hide_channel_group_ids: (state) => state.hide_channel_group_ids,
    hide_channel_all_group_ids: (state) => {
      return Object.values(state.hide_channel_group_ids).flat() || []
    },
    hide_channel_group_info: (state) => state.hide_channel_group_info,
    has_more_channel_group: (state) => state.has_more_channel_group,
    out_screen_group_info: (state) => state.out_screen_group_info,
    cur_team_channel: (state) => state.cur_team_channel,
    // 判断是否开启定制频道和权限组
    open_customization_and_question: (state) => {
      return state.cur_room_whole_data.room?.customization?.customization_switch && state.cur_room_whole_data.room?.customization?.question_switch
    },
    room_team_binds: (state) => state.room_team_binds,
    host_mode: (state) => {
      return Boolean(state.cur_channel_data.host_mode)
    },
    hosts: (state) => {
      if (Boolean(state.cur_channel_data.host_mode)) {
        return state.hosts
      } else {
        return []
      }
    },
    is_me_applying_host: (state) => {
      return state.is_me_applying_host
    },
    applying_host_users: (state) => {
      return state.applying_host_users
    },
    cur_global_team: (state) => state.cur_global_team,
    global_team_setting: (state) => state.global_team_setting,
  },
  mutations: {
    SET_CUR_ROOM_DATA (state, val) {
      state.cur_room_whole_data.room = {
        ...(state.cur_room_whole_data.room || {}),
        ...val
      }
    },
    SET_CUR_ROOM_WHOLE_DATA (state, val) {
      state.cur_room_whole_data = val
    },
    SET_CUR_ROOM_WHOLE_DATA_KEY (state, {key, value}) {
      state.cur_room_whole_data[key] = value
    },
    CLEAR_CUR_ROOM_WHOLE_DATA (state) {
      state.cur_room_whole_data = {}
    },
    SET_CUR_TEXT_CHANNEL_DATA (state, val) {
      state.cur_text_channel_data = val
    },
    SET_CUR_CHANNEL_DATA (state, val) {
      state.cur_channel_data = val
    },
    SET_CHANNEL_CONNECTING (state, val) {
      state.channel_connecting = val
    },
    SET_ENTER_CHANNEL_WS_CONNECTING_CHANNEL_ID (state, val) {
      state.enter_channel_ws_connecting_channel_id = val
    },
    SET_RCT_CONNECTING (state, val) {
      state.rtc_connection = val
    },
    SET_TOP_ROOM_ID(state, val) {
      state.top_room_id = val
    },
    SET_ROOM_LIST(state, val) {
      state.room_list = val
    },
    SET_TEMP_ROLE_DATA(state, val) {
      state.temp_role_data = val
    },
    SET_CUSTOM_ROOM_EMOJI(state, val) {
      val.emojis = val.emojis.filter((v, i, arr) => arr.findIndex(t => t.path === v.path) === i)
      val.stickers = val.stickers.filter((v, i, arr) => arr.findIndex(t => t.path === v.path) === i)
      state.customRoomEmoji = val;
    },
    SET_ALL_NOTIFY_SETTINGS(state, val) {
      state.all_notify_settings = val
    },
    SET_ALL_NOTIFY_SETTINGS_PARAMS(state, {room_id, newVal}) {
      state.all_notify_settings[room_id] = newVal
    },
    SET_DEFAULT_NOTIFY_SETTINGS(state, val) {
      state.default_notify_settings = val
    },
    SET_ALL_UNREAD_STATES(state, val) {
      state.all_unread_states = val
    },
    SET_BGM_STATE(state, val) {
      state.bgm_state = val
    },
    SET_SOUND_MESSAGE_ACTIVE(state, val) {
      state.sound_message_active = {
        ...state.sound_message_active,
        ...val
      }
    },
    SET_PREVIEW_THEME_DATA(state, val) {
      state.preview_theme_data = val
    },
    SET_CUR_ROOM_BANNED_TIME(state, val) {
      state.cur_room_banned_time = val
    },
    SET_ANCHOR_MUTE_USER_IDS(state, val) {
      let anchor_white_list = state.anchor_white_list
      if (anchor_white_list.length > 0) {
        for(let white_user of anchor_white_list) {
          if(val[white_user.user_id]) {
            delete val[white_user.user_id]
          }
        }
      }
      Object.keys(val).forEach(key => {
        val[key] = {
          ...val[key],
          user_id: String(val[key].user_id)
        }
      })
      state.anchor_mute_user_ids = val
    },
    SET_SHOW_THEME_MANAGER(state, val) {
      state.show_theme_manager = val
    },
    SET_IS_PHONE_MIC_CONNECTING(state, val) {
      state.is_phone_mic_connecting = val
    },
    SET_ROOM_CHANNEL_LIST_SCROLL_TOP(state, val) {
      state.room_channel_list_scroll_top = val
    },
    SET_ENTER_DEFAULT_CHANNEL_RESULT (state, val) {
      state.enter_default_channel_result = val
    },
    SET_IS_FROM_TEAM_CENTER (state, val) {
      state.is_from_team_center = val
    },
    SET_IS_FROM_TEAM_CARD (state, val) {
      state.is_from_team_card = val
    },
    SET_TEMP_PRIVATE_INVITE(state, val) {
      state.temp_private_invite = val
    },
    SET_ANCHOR_WHITE_LIST(state, val) {
      state.anchor_white_list = val
    },
    SET_STASH_ROOM_DATA(state, val) {
      state.stash_room_data = val
    },
    SET_ROOM_MEMBER_NUM(state, val) {
      state.room_member_num = val
    },

    SET_NEW_MEMBER_GUIDE(state, val){
      state.new_member_guide = {
        ...state.new_member_guide,
        ...val
      }
    },
    SET_NEW_MEMBER_GUIDER_CONFIG(state, val){
      state.new_member_guider_config = val
    },

    // 设置房间接收消息推送
    SET_ROOM_NOTIFY_SETTINGS(state, val) {
      state.cur_room_whole_data.user_notify_settings = {
        ...state.cur_room_whole_data.user_notify_settings,
        ...val
      }
    },

    // 设置房间的定制体验
    SET_ROOM_CUSTOMIZATION(state, val) {
      state.cur_room_whole_data.my_room_info.customization = val
    },

    // 设置房间的定制体验
    SET_ROOM_CUSTOMIZATION_RESPONSES(state, val) {
      state.cur_room_whole_data.my_room_info.customization.responses = val
    },

    SET_INDEX_TASK(state, val) {
      state.index_task = val
    },

    // 记录首页进入房间的方式
    SET_DISCOVER_ENTER_WAY(state, val){
      state.discover_enter_way = val;
    },

    SET_IS_SPEAK_FREELY(state, val) {
      state.is_speak_freely = val
    },

    // 更新用户活跃天数
    SET_ROOM_USER_CONTINUOUS_DAYS(state, val) {
      state.cur_room_whole_data.my_room_info.continuous_days = val
    },

    // 更新用户的房间活动未读数
    SET_ROOM_USER_ACTIVITY_UNREAD(state, val) {
      state.cur_room_whole_data.my_room_info.room_act_unread_count = val
    },

    // 更新用户的房间活动最后一个关闭的ID
    SET_CUR_ROOM_LAST_CLOSE_ROOM_ACT_ID(state, val) {
      state.cur_room_whole_data.my_room_info.last_close_room_act_id = val
    },

    // 更新当前房间阅读房间公告的时间
    SET_CUR_ROOM_READ_ANC_TIME(state, val) {
      state.cur_room_whole_data.my_room_info.read_anc_time = val
    },

    // 更新当前用户正在游玩组件展示情况
    SET_IS_SHOW_GAME_DISPLAY_BLOCK(state, val) {
      state.is_show_game_display_block = val
    },

    // 更新多人语音折叠数组
    SET_EXPEND_COLLAPSE_IDS(state, val) {
      state.expend_collapse_ids = val
    },

    // 更新用户手动展开的频道ID列表
    SET_MANUALLY_EXPANDED_CHANNEL_IDS(state, val) {
      state.manually_expanded_channel_ids = val
    },

    // 设置当前房间指南缓存
    SET_ROOM_GUIDANCE_DATA(state, val) {
      state.room_guidance_data = val
    },

    SET_CUR_RESOURCE_CHANNEL_DATA(state, val) {
      state.cur_resource_channel_data = val
    },

    SET_WAIT_ENTER_TEMPORARY_CHANNEL_ID(state, val) {
      state.wait_enter_temporary_channel_id = val
    },
    SET_MSG_CHANNELS(state, value) {
      state.msg_channels = value
    },
    SET_HIDE_CHANNEL_GROUP_IDS(state, val) {
      state.hide_channel_group_ids = {
        ...state.hide_channel_group_ids,
        ...val
      }
    },
    SET_HIDE_CHANNEL_GROUP_INFO(state, val) {
      state.hide_channel_group_info = {
        ...state.hide_channel_group_info,
        ...val
      }
    },
    CLEAR_HIDE_CHANNEL_GROUP_INFO(state, channel_id) {
      if (channel_id) {
        if (state.hide_channel_group_info[channel_id]) {
          delete state.hide_channel_group_info[channel_id]
        }
      } else {
        state.hide_channel_group_info = {}
      }
    },
    SET_OUT_SCREEN_GROUP_INFO(state, val) {
      if (val) {
        state.out_screen_group_info[val.channel_id] = val
      }
    },
    CLEAR_OUT_SCREEN_GROUP_INFO(state, channel_id) {
      if (channel_id) {
        if (state.out_screen_group_info[channel_id]) {
          state.out_screen_group_info[channel_id] = undefined
        }
      } else {
        state.out_screen_group_info = {}
      }
    },
    SET_HAS_MORE_CHANNEL_GROUP(state, val) {
      state.has_more_channel_group = val
    },

    SET_CUR_TEAM_CHANNEL(state, val) {
      state.cur_team_channel = val ? {
        timestamp: Date.now(),
        channel_id: val
      } : {}
    },
    SET_ROOM_TEAM_BINDS(state, val) {
      state.room_team_binds = val
    },
    SET_HOST_MODE(state, { val, channel_id }) {
      if(state.cur_channel_data.channel_id === channel_id) {
        state.cur_channel_data.host_mode = val
      }
    },
    SET_APPLYING_HOST_USERS(state, val) {
      state.applying_host_users = val
    },
    SET_IS_ME_APPLYING_HOST(state, val) {
      state.is_me_applying_host = val
    },
    SET_CHANNEL_HOSTS(state, val) {
      state.hosts = val
    },
    SET_CUR_GLOBAL_TEAM(state, val) {
      state.cur_global_team = val
    },
    SET_GLOBAL_TEAM_SETTING(state, val) {
      state.global_team_setting = val
    },
  },
  actions: {
    SET_TEMP_ROLE_DATA({ commit, state }, val){
      permission.clearPermissionCache()
      if(state.cur_text_channel_data.channel_type === CHANNEL_TYPES.experiment){
        commit('SET_CUR_TEXT_CHANNEL_DATA', {})
      }
      commit('SET_TEMP_ROLE_DATA', val)
    },
    SET_SINGLE_MEMBER_VOICE_LEVEL: ({ commit, state, dispatch }, {level, user_id}) => {
      if (level > 0) {
        let _anchor_mute_user_ids = JSON.parse(JSON.stringify(state.anchor_mute_user_ids))
        let user = _anchor_mute_user_ids[user_id]
        if (user && !user.ignore) { // 如果是在主播模式静音后手动调整了音量，将用户在静音列表中标记为失效
          user.ignore = true
          commit('SET_ANCHOR_MUTE_USER_IDS', _anchor_mute_user_ids)
        }
      }
      let obj = {}
      obj[user_id] = level;
      dispatch('SET_MEMBER_VOICE_LEVEL', obj);
      Vue.prototype.$rtc.changeUserVolume(user_id);
    },
    SET_BGM_MEMBER_VOICE_LEVEL: ({ dispatch }, {level, user_id}) => {
      user_id = user_id + USER_BGM_SUFFIX
      dispatch('SET_SINGLE_MEMBER_VOICE_LEVEL', {level, user_id})
    },
    SET_ROOM_LIST({commit, rootState}, val) {
      // 如果开启了obs覆盖，更新房间列表时通知electron
      if(rootState.settings.obs_auth && process.env.IS_CLIENT){
        window.obsOverlayAPI.updateRoomList(getBasicRoomData(val))
      }
      commit('SET_ROOM_LIST', val)
    },
    SET_ANCHOR_WHITE_LIST({ commit, state }, val) {
      let _anchor_mute_user_ids = JSON.parse(JSON.stringify(state.anchor_mute_user_ids))
      let change_user_ids = []
      for (let user of val) {
        let anchor_user = _anchor_mute_user_ids[user.user_id]
        if (anchor_user && !anchor_user.ignore) { // 如果是在主播模式静音后添加到了主播模式白名单，将用户在静音列表中标记为失效
          anchor_user.ignore = true
          change_user_ids.push(user.user_id)
        }
      }
      commit('SET_ANCHOR_WHITE_LIST', val)
      if (change_user_ids.length > 0) {
        commit('SET_ANCHOR_MUTE_USER_IDS', _anchor_mute_user_ids)
      }
      change_user_ids.forEach(user_id => {
        Vue.prototype.$rtc.changeUserVolume(user_id);
      })
    },
    SET_HOST_MODE({ commit, state }, val) {
      const curChannelId = state.cur_channel_data.channel_id
      setChannelSettings({}, {
        channel_id: curChannelId,
        room_id: state.cur_room_whole_data.room.room_id,
        setting: 'host_mode',
        value: Boolean(val) ? 1 : 0,
      }).then((res) => {
        if(res.data.status === 'ok') {
          commit('SET_HOST_MODE', {
            val,
            channel_id: curChannelId,
          })
        }
      })
    },
  }
}

export default Room